<template>
    <div class="queryResults">
        <bread :data="breadData"/>
        <div class="queryResults-center center-wrapper" v-if="$route.query.isTrueResults">
            <div class="queryResults-center-left" style="width: 66%" v-if="dataList.sample_info">
                <div class="queryResults-center-left-Topabout">
                    <div class="queryResults-center-left-img">
                        <img :src="dataList.img_list[0]" alt="" width="100%">
                        <p class="center-left--img-title">{{ dataList.conclusion }}</p>
                        <p>承检机构：{{ dataList.inspection_station_name }}</p>
                        <p>证书防伪码：{{ dataList.gem_remarks }}</p>

                    </div>
                    <ul class="queryResults-center-left-about">
                        <li class="queryResults-center-left-about-item" v-for="(item, index) of dataList.sample_info.sample_list" :key='index'>
                            <div style="margin: 13px 25px" :style="{
                marginTop: index==0 ? '0px' : '12.6px'
              }" class="about-item-content">
                                <div class="about-item-title">
                  <span style="font-size: 17px" v-html="item.name.split('<br/>')[0]">
                  </span>
                                    <span class="about-item-minTitle" v-if="item.name.split('<br/>')[1]" v-html="item.name.split('<br/>')[1]">
                  </span>
                                </div>
                                <div class="about-item-cs">
                                    <img width="60px" :src="item.value" alt="" v-if="item.display_type">
                                    <span v-else>
                    {{ item.value }}
                  </span>
                                </div>
                            </div>
                            <fgx style="margin-bottom: 0;padding:0" v-if="index!=queryCertificate.length-1"/>
                        </li>
                    </ul>
                </div>
                <p class="center-left-zhushi">
                    {{ dataList.gem_remarks }}
                </p>
                <img class="mfzxImg" src="@/assets/img/queryResultsMFZX.png" @click="()=>$router.push('/Expert')" alt="" width="100%">
                <div class="queryResults-left-zhishiku">
                    <div class="queryResults-left-zhishiku-toptitle">
                        <img class="queryResults-left-zhishikuimg" src="@/assets/img/Vector.svg" alt="" width="38px">
                        <span>
            知识+
            </span>
                    </div>
                    <div class="queryResults-left-zhishiku-content" v-if="dataList.knowledge_info">
                        <img :src="dataList.knowledge_info.img_url" alt="" width="120px" class="queryResults-left-zhishiku-conten-leftimg">
                        <div class="queryResults-left-zhishiku-conten-right">
                            <h1 class="zhishiku-conten-right-title">
                                {{ dataList.knowledge_info.profile }}
                            </h1>
                            <ul class="zhishiku-conten-right-tabs">
                                <li class="zhishiku-conten-right-tabs-items">
                                    关联品类
                                </li>
                            </ul>
                            <p class="zhishiku-conten-right-footertext">
                                {{ dataList.knowledge_info.label }}
                            </p>
                        </div>
                    </div>
                    <div class="queryResults-left-byff">
                        <span v-html="dataList.knowledge_info.introduce" class="queryResults-left-byff-item-content"></span>
                        <!--            <h1  class="queryResults-left-byff-title">保养方法</h1>
                                    <ul class="queryResults-left-byff-List">
                                      &lt;!&ndash; <li class="queryResults-left-byff-item">
                                        <div class="queryResults-left-byff-item-icon">
                                          {{1}}
                </div>
                <span class="queryResults-left-byff-item-content"  v-html="dataList.knowledge_info.introduce">
                </span>
              </li> &ndash;&gt;
              <li class="queryResults-left-byff-item" v-for="(item, index) of dataList.knowledge_info.introduce.replace('<p>','').replace('</p>','').split('。').filter(item => item)" :key="index">
                <div class="queryResults-left-byff-item-icon">
                  {{index + 1}}
                </div>
                <span class="queryResults-left-byff-item-content">
                  {{item}}。
                </span>
              </li>
            </ul>-->
                    </div>
                </div>
            </div>
            <div class="queryResults-center-right" style="width: 32%;min-width: 370px;margin-left: 30px" v-if="dataList.trace_info">
                <div class="zssl-content">
                    <titleBar title="证书溯源">
                        <img slot="icon" src="@/assets/img/Buildings@1x.svg" alt="">
                    </titleBar>
                    <div class="zssl-content-syrz">
                        <div class="zssl-content-left">
                            <img src="@/assets/img/Frame 33.png" width="20px" alt="">
                            <span>溯源日志</span>
                        </div>
                        <ul class="zssl-content-right">
                            <li class="zssl-content-right-item" v-for="(item, nodeKey) in dataList.trace_info.node_log_list" :key="nodeKey">
                <span class="zssl-content-right-item-title">
                  {{ item.time }}
                </span>
                                <span class="zssl-content-right-item-time">
                  {{ item.name }}
                </span>
                            </li>
                        </ul>

                    </div>
                    <div class="zssl-content-syrz">
                        <div class="zssl-content-left">
                            <img src="@/assets/img/Frame 33.png" width="20px" alt="">
                            <span>查询日志</span>
                        </div>
                        <div class="zssl-content-right">
                            <div style="display: flex" class="zssl-content-right-item trace-list" v-for="(item, queryKey) in dataList.trace_info.query_log_list"
                                 :key="queryKey">
                                <div style="margin: 0 4px;" class="nowrap zssl-content-right-item-title" >
                                    {{ item.type_name }}
                                </div>
                                <div class="nowrap zssl-content-right-item-time">
                                    {{ item.time }}
                                </div>
                                <div style="display: flex;" class="nowrap zssl-content-right-item-gsd ">
                                    <div class="zssl-content-right-item-ip" style="margin-left: 4px">
                                        ip
                                    </div>
                                    <div style="max-width: 60px;overflow: hidden;text-overflow: ellipsis;" class="nowrap zssl-content-right-item-dizhi" :title="item.province">
                                        {{ item.province }}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="cjjgxx-content">
                    <titleBar title="承检机构信息">
                        <img slot="icon" src="@/assets/img/ListChecks@1x.svg" alt="">
                    </titleBar>
                    <img :src="dataList.inspection_station_info.certified_image" alt="" width="100%">
                    <div class="cjjgxx-content-syrz">
                        <ul class="cjjgxx-content-right">
                            <!--              <li class="cjjgxx-content-right-item" v-for="item of dataList.inspection_station_info.station_list" :key="item[0]">
                                            <span class="cjjgxx-content-right-item-title">
                                              {{item[0]}}：
                </span>
                <span class="cjjgxx-content-right-item-time">
                  {{item[1]}}
                </span>
              </li>-->
                            <li class="cjjgxx-content-right-item">
                <span class="cjjgxx-content-right-item-title">
                  机构名称：
                </span>
                                <span class="cjjgxx-content-right-item-time">
                  {{ dataList.inspection_station_info.inspection_station_name }}
                </span>
                            </li>
                            <li class="cjjgxx-content-right-item">
                <span class="cjjgxx-content-right-item-title">
                  联系电话：
                </span>
                                <span class="cjjgxx-content-right-item-time">
                  {{ dataList.inspection_station_info.phone_list ? dataList.inspection_station_info.phone_list[0] : '' }}
                </span>
                            </li>
                            <li class="cjjgxx-content-right-item">
                <span class="cjjgxx-content-right-item-title">
                  官方网站：
                </span>
                                <a target="_blank"
                                   :href="dataList.inspection_station_info.website_list?dataList.inspection_station_info.website_list[0]:''"
                                   class="cjjgxx-content-right-item-time">
                                    {{ dataList.inspection_station_info.website_list ? dataList.inspection_station_info.website_list[0] : '' }}
                                </a>
                            </li>
                            <li class="cjjgxx-content-right-item">
                <span class="cjjgxx-content-right-item-title">
                  机构地址：
                </span>
                                <span v-html="dataList.inspection_station_info.address" class="cjjgxx-content-right-item-time"></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="queryResults" v-else>
            <div class="center-wrapper queryResults-content">
                <img src="@/assets/img/noZs-content-image.svg" alt="" width="30%">
                <p style="margin-top: 20px">哎呀，</p>
                <p>没有查到您的证书数据呢！</p>
            </div>
        </div>
        <div class="center-wrapper" v-if="!$route.query.isTrueResults">
            <div class="queryResults-content-tips">
                <span>可能原因：① 站点数据未上传     ② 数据库异常     ③ 此证书为假证书</span>
            </div>
            <p class="queryResults-content-tipst">为确保这不是最坏的结果，请您尽快与我们联系。拨打电话：400-900-5991</p>
        </div>
    </div>
</template>

<script>
import fgx from '@/components/fgx/index'
import titleBar from './components/titleBar'
import bread from '@/components/com-breadcrumb'
import {certificate} from '@/api/api';

export default {
    components: {
        fgx,
        titleBar,
        bread
    },
    data() {
        return {
            dataList: {},
            breadData: [
                {
                    title: '甄宝阁',
                    to: '/'
                }, {
                    title: '证书查询结果'
                }
            ],
            queryCertificate: [
                {
                    title: '检测编号',
                    minTitle: '(No.)',
                    content: '620562004611'
                }, {
                    title: '鉴定结果',
                    minTitle: '(No.)',
                    content: '海水珍珠耳坠'
                }, {
                    title: '总质量',
                    minTitle: '(No.)',
                    content: '2.32g'
                }, {
                    title: '颜色',
                    minTitle: '(No.)',
                    content: '620562004611'
                }, {
                    title: '密度',
                    minTitle: '(No.)',
                    content: '620562004611'
                }, {
                    title: '放大检测',
                    minTitle: '(No.)',
                    content: '颗粒状'
                }, {
                    title: '配石',
                    minTitle: '(No.)',
                    content: ''
                }, {
                    title: '鉴定师',
                    minTitle: '(No.)',
                    content: 'xxx'
                }, {
                    title: '审核人',
                    minTitle: '(No.)',
                    content: 'xxx'
                }, {
                    title: '验证码',
                    minTitle: '(No.)',
                    content: '9987'
                },
            ]
        }
    },
    created() {
        this.$route.query.isTrueResults = this.$route.query.isTrueResults === 'true';
        let params = Object.assign({}, this.$route.query);
        delete params.isTrueResults;
        if (this.$route.query.isTrueResults) {
            this.$loading({
                fullscreen: true
            })
            certificate(params).then(r => {
                this.$set(this, 'dataList', r.data.data);
            }).finally(() => {
                this.$loading().close()
            })
        }
    }
}
</script>

<style lang='scss'>
.queryResults {
    .queryResults-header {
        height: 50px;
        background: rgb(45, 149, 200);
        display: flex;
        align-items: center;

        .el-icon-arrow-right {
            color: #fff;
        }

        .el-breadcrumb__inner {
            color: #fff !important;
        }

        .el-breadcrumb__inner.is-link {
            font-weight: 500;
        }
    }

    .queryResults-center {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
    }

    .queryResults-center-left {
        .queryResults-left-zhishiku {
            margin-top: 70px;

            .queryResults-left-zhishiku-toptitle {
                margin-left: 10px;
                display: flex;
                font-size: 30px;
                color: rgba(41, 43, 44, 1);
                font-weight: 600;

                > span {
                    margin-left: 10px
                }
            }

            .queryResults-left-zhishiku-content {
                display: flex;
                margin-top: 40px;
                width: 100%;
                height: 145px;
                background: #fff;
                padding: 10px;

                .queryResults-left-zhishiku-conten-leftimg {
                    margin-right: 10px;
                    width: 120px;
                }

                .queryResults-left-zhishiku-conten-right {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }

                .zhishiku-conten-right-title {
                    color: rgba(41, 43, 44, 1);
                    font-size: 18px;
                    line-height: 20.8px;
                    font-weight: 600;
                }

                .zhishiku-conten-right-tabs {
                    color: rgba(255, 255, 255, 1);
                    font-size: 14px;
                    display: flex;

                    .zhishiku-conten-right-tabs-items {
                        background: rgba(16, 77, 144, 1);
                        border-radius: 30px;
                        margin-right: 10px;
                        padding: 5px 10px;
                    }
                }

                .zhishiku-conten-right-footertext {
                    color: rgba(105, 109, 111, 1);
                    font-size: 14px;
                }
            }

            .queryResults-left-byff {
                margin-top: 20px;
                padding: 10px;
            }

            .queryResults-left-byff-List {
                padding-top: 10px;

                .queryResults-left-byff-item {
                    margin: 10px 0;
                    font-size: 14px;
                    color: rgba(105, 109, 111, 1);
                    display: flex;
                    align-items: center;

                    .queryResults-left-byff-item-icon {
                        margin-right: 10px;
                        background: rgba(105, 109, 111, 1);
                        padding: 2px 5px;
                        font-size: 10px;
                        color: rgb(236, 236, 236);
                        border-radius: 3px;
                    }
                }
            }
        }

        .center-left-zhushi {
            margin: 20px 0;
            color: rgba(105, 109, 111, 1);
            font-size: 14px
        }

        .mfzxImg {
            margin-top: 20px;
            cursor: pointer;
        }

        .queryResults-center-left-Topabout {
            background: #fff;
            display: flex;
        }

        .queryResults-center-left-img {
            padding: 17px;
            padding-bottom: 25px;
            width: 43%;
            background: rgb(32, 147, 202);
            text-align: center;
            color: #fff;
            font-weight: 200;

            .center-left--img-title {
                text-shadow: 1px 2px 0px rgba(0, 0, 0, 0.25);
                font-size: 24px;
                font-weight: 600;
                margin-top: 20px;
            }

            p {
                margin-top: 15px;
            }
        }

        .queryResults-center-left-about {
            padding: 16px;
            padding-bottom: 11px;

            .about-item-content {
                display: flex;
                justify-content: space-between;
            }

            .about-item-minTitle {
                font-size: 14px;
                color: rgba(166, 166, 166, 1);
                margin-left: 5px;
            }

            .about-item-cs {
                color: rgba(26, 26, 26, 1);
            }
        }

        .queryResults-center-left-about {
            width: 57%;
            height: 100%;
        }
    }

    .cjjgxx-content {
        margin-top: 45px;
    }

    .zssl-content, .cjjgxx-content {
        .zssl-content-syrz {
            margin-top: 10px;
        }

        .zssl-content-syrz, .cjjgxx-content-syrz {
            display: flex;
            font-size: 14px;
            background: #fff;
            padding: 10px;

            .zssl-content-right {

            }

            .zssl-content-left, .cjjgxx-content-left {
                width: 20%;
                background: rgba(240, 240, 240, 1);
                box-shadow: 0px 4px 6px rgba(105, 109, 111, 0.04);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

            .zssl-content-right-item:last-child, .cjjgxx-content-right-item:last-child {
                padding-bottom: 0;
                border-bottom: none;
            }

            .zssl-content-right-item:first-child, .cjjgxx-content-right-item:first-child {
                padding-top: 0;
            }

            .zssl-content-right-item, .cjjgxx-content-right-item {
                border-bottom: 1px solid rgba(240, 240, 240, 1);
                padding: 10px 0;
                color: rgba(41, 43, 44, 1);
                font-size: 15px;
                font-weight: 400;

                .zssl-content-right-item-title, .cjjgxx-content-right-item-title {
                    margin: 0 10px
                }

                .zssl-content-right-item-gsd {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    word-wrap: break-word;
                }

                .flex-elli {
                    line-height: 32px;
                    display: flex;
                    width: 80px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    word-wrap: break-word;
                }
                .nowrap{
                    white-space: nowrap;
                    word-wrap: break-word;
                }
                .zssl-content-right-item-time, .cjjgxx-content-right-item-time {
                    color: rgba(114, 113, 113, 1);
                    font-size: 14px;
                }

                .zssl-content-right-item-dizhi, .cjjgxx-content-right-item-dizhi {
                    color: rgba(16, 77, 144, 1);
                    font-size: 14px;
                    margin-left: 5px
                }

                .zssl-content-right-item-dizhi {

                }

                .zssl-content-right-item-ip, .cjjgxx-content-right-item-ip {
                    display: inline-block;
                    width: 18px;
                    transform: scale(0.8);
                    height: 18px;
                    line-height: 16px;
                    text-align: center;
                    color: rgba(255, 255, 255, 1);
                    font-size: 12px;
                    font-weight: 400;
                    background: rgba(16, 77, 144, 1);
                    border-radius: 100%;
                }
            }

            .cjjgxx-content-right {
                width: 100%;
            }

            .cjjgxx-content-right-item {
                display: flex;
                width: 100%;
                justify-content: space-between;
                border-bottom: none;
            }

            .cjjgxx-content-right-item-time {
                font-size: 16px;
            }
        }
    }

    .queryResults-content {
        box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.03);
        font-weight: 700;
        color: rgba(105, 109, 111, 1);
        font-size: 24px;
        line-height: 45px;
        padding: 90px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        background: #fff;
        margin-top: 70px;
        margin-bottom: 43px;
    }

    .queryResults-content-tips {
        display: flex;
        justify-content: center;

        span {
            padding-bottom: 15px;
            border-bottom: 1px solid rgba(166, 166, 166, 1);
        }

        color: rgba(105, 109, 111, 1);
        font-size: 20px;
        font-weight: 400;
        text-align: center;
    }

    .queryResults-content-tipst {
        margin-top: 15px;
        color: rgba(166, 166, 166, 1);
        font-size: 16px;
        font-weight: 400;
        text-align: center;
    }
}
</style>